import {
  PolymorphicForwardedRef,
  PolymorphicProps,
} from '@axa-ch/react-polymorphic-types';
import { PropsWithChildren } from 'react';

import { cn } from '~/lib/utils/classname';

type Slots = 'main' | 'inner';

export const defaultElement: React.ElementType = 'div' as const;
export type AllowedElements =
  | typeof defaultElement
  | keyof React.JSX.IntrinsicElements;

export type OwnProps<E extends AllowedElements> =
  React.ComponentPropsWithoutRef<E> & {
    className?: string;
    classNames?: Partial<Record<Slots, string>>;
    grid?: boolean;

    ref?: PolymorphicForwardedRef<E>;
  } & PropsWithChildren &
    React.JSX.IntrinsicAttributes;

export type Props<T extends AllowedElements> = PolymorphicProps<
  OwnProps<T>,
  T,
  AllowedElements
>;

const LayoutContainer = <E extends AllowedElements = typeof defaultElement>({
  as: asComponent,
  className,
  classNames,
  grid,
  children,
}: Props<E>) => {
  const OuterComponent = asComponent || defaultElement;

  return (
    <OuterComponent
      className={cn(
        'relative w-full px-4 md:px-24',
        className,
        classNames?.main
      )}
    >
      <div
        className={cn(
          'max-w-comp-w relative mx-auto w-full',
          classNames?.inner,
          {
            'grid grid-cols-2 gap-x-4 md:grid-cols-12 md:gap-x-10': grid,
          }
        )}
      >
        {children}
      </div>
    </OuterComponent>
  );
};

export default LayoutContainer;
